var map = {
	"./antispam.jpg": "0334",
	"./antispamsystem.jpg": "2723",
	"./b2b.jpg": "f9a0",
	"./cinemaad.jpg": "a6dc",
	"./comments.jpg": "0ea8",
	"./contentcoorditanion.jpg": "f1ca",
	"./contentdelivery.jpg": "916a",
	"./cpx.jpg": "7ca4",
	"./identity.jpg": "d0f8",
	"./intranet.jpg": "5e8e1",
	"./invmodel.jpg": "bcd6",
	"./leto.jpg": "0871",
	"./look.jpg": "db44",
	"./newsaggregator.jpg": "6626",
	"./okkokontent.jpg": "3538",
	"./ottplatform.jpg": "38ec",
	"./polls.jpg": "e115",
	"./recomendsystems.jpg": "bef3",
	"./rekko.jpg": "344e",
	"./rid.jpg": "247d",
	"./smartheater.jpg": "fac9",
	"./ssp.jpg": "8b24",
	"./unity.jpg": "6120",
	"./usermodel.jpg": "ec50",
	"./videoplatform.jpg": "c0ee",
	"./webanalytic.jpg": "c4a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b680";